/**
 * ReduxProvider Component
 *
 * This component wraps its children with the Redux Provider, making the Redux store
 * available throughout the React component tree. Use this at the root of your app
 * to enable Redux state management.
 *
 * Props:
 * - children: React nodes to be rendered within the provider
 *
 * Exports:
 * - ReduxProvider: The provider component for Redux store
 */

"use client";
import React from "react";
import { Provider } from "react-redux";
import { store } from "..";

interface ReduxProviderProps {
  children: React.ReactNode;
}

const ReduxProvider = ({ children }: ReduxProviderProps) => {
  return <Provider store={store}>{children}</Provider>;
};

export default ReduxProvider;
